import { i18n } from "services/i18nService";

import { OBJECT_TYPES } from "appConstants";

export const SETTINGS = [
  { apiName: "useQBInvoiceNumber", component: "FrmCheckbox" },
  {
    apiName: "invoiceNumber",
    component: "FrmTransactionNumber",
    transactionType: OBJECT_TYPES.INVOICE.fullString,
    hasInputLabel: true,
  },
  { apiName: "replyEmailInvoice", component: "FrmEmail", maxLength: 255 },
  {
    apiName: "invoiceEmail",
    component: "FrmResizeTextField",
    explanationOverride: (
      <>
        {i18n("settings.sales.invoices.invoiceEmail.explanation.1")}
        <p>{i18n("settings.sales.invoices.invoiceEmail.explanation.2")}</p>
        <div>{i18n("settings.sales.invoices.invoiceEmail.explanation.3")}</div>
      </>
    ),
  },
  { apiName: "invoiceFooter", component: "FrmResizeTextField" },
  { apiName: "defaultCCInvoice", component: "FrmEmail", maxLength: 255 },
  { apiName: "useShippingCostFromShipment", component: "FrmCheckbox" },
];
